import { DialogComponent, DialogCloseEvent } from '@theme/dialog';

const STORAGE_KEY = 'welcome-offer-seen';
const SHOW_DELAY_MS = 3000;

/**
 * A custom element that manages the "10% off your first order" welcome popup.
 * Auto-opens once per browser (after a short delay) for first-time guests,
 * and re-opens immediately to show a success or error state after the
 * newsletter signup form posts back.
 *
 * @extends DialogComponent
 */
class WelcomeOfferDialog extends DialogComponent {
  /** @type {number | undefined} */
  #timeoutId;

  connectedCallback() {
    super.connectedCallback();

    this.addEventListener(DialogCloseEvent.eventName, this.#markSeen);

    const shouldReopen = this.querySelector('[data-welcome-offer-reopen]');
    if (shouldReopen) {
      this.showDialog();

      if (this.querySelector('[data-welcome-offer-success]')) {
        this.#markSeen();
      }

      return;
    }

    if (this.#hasBeenSeen()) return;

    this.#timeoutId = window.setTimeout(() => {
      this.showDialog();
    }, SHOW_DELAY_MS);
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    window.clearTimeout(this.#timeoutId);
    this.removeEventListener(DialogCloseEvent.eventName, this.#markSeen);
  }

  /**
   * @returns {boolean}
   */
  #hasBeenSeen() {
    try {
      return window.localStorage.getItem(STORAGE_KEY) === 'true';
    } catch (error) {
      return false;
    }
  }

  #markSeen = () => {
    try {
      window.localStorage.setItem(STORAGE_KEY, 'true');
    } catch (error) {
      // Storage unavailable (private browsing, disabled storage, etc.) — safe to ignore.
    }
  };
}

if (!customElements.get('welcome-offer-dialog')) {
  customElements.define('welcome-offer-dialog', WelcomeOfferDialog);
}
